import {TyrePositionEnum} from "../../../../enums";

export interface VehicleTyresInfoDTO {
  tyres: VehicleTyreInfoDTO[];
}

export interface VehicleTyreInfoDTO {
  position: TyrePositionEnum;
  make: string;
  condition: string;
  depth?: number;
}
